import { createI18n } from 'vue-i18n'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const messages = require('./messages.json')

const isServer = typeof window === 'undefined'

const language = isServer ? 'ja' : localStorage.language || (
  window.navigator.languages && window.navigator.languages[0]
) || window.navigator.language

export default createI18n({
  legacy: false,
  locale: (language === 'ja' || language === 'ja-JP') ? 'ja' : 'en',
  allowComposition: true,
  messages,
  modifiers: {
  }
})
